module.exports = __webpack_public_path__ + "static/media/1_Plug-in-to-power.85eea41e.svg";